import React, { useEffect, useState } from 'react';
import axios from 'axios';
import moment from 'moment';
import ModalPopupMessage from '../../../components/modal/ModalPopupMessage';
import CardInverter from '../../../components/card/CardInverter';
import ModalLoad from '../../../components/modal/ModalLoad';
import '../historical/historical_rawdata.css';
import ScrollToTopButton from '../../../components/extra/ScrollToTopButton.js';
import DeviceInfo_Inverter from '../../../components/device_info/DeviceInfo_Inverter.js';

function MeasurementInverters(props) {
    const [data_status_indicator, setData_status_indicator] = useState({
        update_time: '-',

    });

    const [chart_mode, setChart_mode] = useState('ac_type');
    const [chart_buffer, setChart_buffer] = useState({
        label: '',
        plot: []
    });
    const [inverter_item, setInverter_item] = useState({
        pvstring: [],
        pvstring_support: 0
    });
    const [inverter_selected, setInverter_selected] = useState('');
    const [modal_load, setmodal_load] = useState({ enable: false, message: "" })
    const [data_inverter, setData_inverter] = useState([]);
    const [data_uioption, setData_uioption] = useState({ inverter_alarm: [] });
    const [string_tag_list, setString_tag_list] = useState([])
    const [string_selected, setString_selected] = useState({
        datakey: '',
        tags: ''
    });
    const [modal_panel, setModal_panel] = useState(false);
    const sleep = ms => new Promise(resolve => setTimeout(resolve, ms))

    useEffect(() => {
        return () => {
            setData_status_indicator({})
            setChart_buffer({})
            setInverter_item({})
            setData_inverter([])
            setData_uioption({})
            setString_tag_list([])
            setChart_plot({})
        };
    }, []);

    useEffect(() => {
        var temp_tag = []
        for (var i = 0; i < 28; i++) {
            var channel = (i + 1)
            temp_tag.push({ table: 'PV String', tagname: 'pv_' + channel + '_p', display: 'PV' + channel + ' Power', value: false, unit: 'kW', index: i, channel: channel })
        }
        setString_tag_list(temp_tag)
    }, []);

    useEffect(() => {
        if (props.data_status_indicator !== null && props.data_status_indicator !== undefined) {
            if (props.data_status_indicator.update_time !== undefined) {
                setData_status_indicator(props.data_status_indicator)
            }
        }
    }, [props.data_status_indicator]);

    useEffect(() => {
        if (props.data_uioption !== null && props.data_uioption !== undefined) {
            if (props.data_uioption.inverter_alarm !== null && props.data_uioption.inverter_alarm !== undefined) {
                setData_uioption(props.data_uioption)
            }
        }
    }, [props.data_uioption]);

    useEffect(() => {
        if (props.data_inverter !== null) {
            setData_inverter(props.data_inverter)
        }
    }, [props.data_inverter]);

    useEffect(() => {
        if (inverter_selected !== '') {
            const found = data_inverter.find((element) => element.inverter_id_text === inverter_selected);
            if (found !== undefined) {
                setInverter_item(found)
                api_get_inverter_power(inverter_selected, found.pvstring_support)
            } else {
                setInverter_item({
                    pvstring: [],
                    pvstring_support: 0
                })
            }
        } else {
            setChart_plot({
                ...chart_plot,
                IRR: [],
                Power: [],
                XLabel: '',
                Tags: '',
            })
            setInverter_item({
                pvstring: [],
                pvstring_support: 0
            })
        }
    }, [inverter_selected, data_inverter]);

    useEffect(() => {
        if (chart_buffer.plot !== undefined) {
            if (chart_buffer.plot.length > 0) {
                let arr1 = []
                let arr2 = []
                let arr3 = []
                for (let i = 0; i < chart_buffer.plot.length; i++) {
                    const dx = new Date(chart_buffer.plot[i].timestamp)

                    arr1.push({ x: dx, y: chart_buffer.plot[i]["env.total_irr_avg"] })
                    arr2.push({ x: dx, y: chart_buffer.plot[i][inverter_selected.toLowerCase() + ".active_power"] })
                    arr3.push({ x: dx, y: chart_buffer.plot[i][inverter_selected.toLowerCase() + ".mppt_power"] })
                }
                if (chart_mode === "ac_type") {
                    setChart_plot({
                        ...chart_plot,
                        IRR: arr1,
                        Power: arr2,
                        XLabel: chart_buffer.label,
                        Tags: 'AC Power',
                    })
                } else {
                    setChart_plot({
                        ...chart_plot,
                        IRR: arr1,
                        Power: arr3,
                        XLabel: chart_buffer.label,
                        Tags: 'DC Power',
                    })
                }
            } else {
                setChart_plot({
                    ...chart_plot,
                    IRR: [],
                    Power: [],
                    XLabel: '',
                    Tags: '',
                })
                setChart_plot_string({
                    ...chart_plot,
                    IRR: [],
                    Power: [],
                    XLabel: '',
                    Tags: '',
                })
            }
        }
    }, [chart_buffer, chart_mode]);

    useEffect(() => {
        if (chart_buffer.plot !== undefined) {
            if (chart_buffer.plot.length > 0 && string_selected.datakey !== "") {
                let arr1 = []
                let arr2 = []
                for (let i = 0; i < chart_buffer.plot.length; i++) {
                    const dx = new Date(chart_buffer.plot[i].timestamp)

                    arr1.push({ x: dx, y: chart_buffer.plot[i]["env.total_irr_avg"] })
                    arr2.push({ x: dx, y: chart_buffer.plot[i][inverter_selected.toLowerCase() + "." + string_selected.datakey] })
                }
                setChart_plot_string({
                    ...chart_plot_string,
                    IRR: arr1,
                    Power: arr2,
                    XLabel: chart_buffer.label,
                    Tags: string_selected.tags,
                })
            } else {
                setChart_plot_string({
                    ...chart_plot_string,
                    IRR: [],
                    Power: [],
                    XLabel: '',
                    Tags: '',
                })
            }
        }
    }, [chart_buffer, string_selected.datakey]);

    const [modal_popup, setModal_popup] = useState({
        modaltype: '',
        headers: '',
        message: '',
        enable: false
    });
    function PopupMsg_onGeneral(message) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
    }

    function PopupMsg_onConfirm(confirmcode) {
        setModal_popup({
            modaltype: '',
            headers: '',
            message: '',
            enable: false
        });
        api_shutdown_send_command(confirmcode)
    }

    const [chart_plot, setChart_plot] = useState({
        XLabel: '',
        Power: [],
        IRR: [],
        Tags: 'AC Power',
        Chart1_Style: {
            irr_type: "line",
            solar_type: "area",
            irr_unit: "W/m2",
            solar_unit: "kW",
            axis_y1: 'Power (kW)',
            axis_y2: 'Irradiation (W/m2)',
            xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: '-'
        }
    });

    const [chart_plot_string, setChart_plot_string] = useState({
        XLabel: '',
        Power: [],
        IRR: [],
        Tags: 'String Power',
        Chart1_Style: {
            irr_type: "line",
            solar_type: "area",
            irr_unit: "W/m2",
            solar_unit: "kW",
            axis_y1: 'Power (kW)',
            axis_y2: 'Irradiation (W/m2)',
            xinterval: 'hour', xformat: 'HH:mm', tooltip_header: 'Timestamp', tooltip_format: 'DD MMM YYYY HH:mm', indexlabel: '-'
        }
    });

    function shutdown_trip(confirmcode) {
        setModal_popup({
            modaltype: 'modal-confirm',
            headers: 'Confirmation',
            message: "Please click on confirm button to continue.",
            enable: true,
            confirmcode: confirmcode
        });
    }

    async function api_get_inverter_power(inverter_id, string_sopport) {
        if (string_sopport > 0) {
            let pv_arr = []
            for (let i = 0; i < string_sopport; i++) {
                pv_arr.push(inverter_id.toLowerCase() + '.pv_' + (i + 1) + "_p")
            }

            const formData = new FormData()
            formData.append('datetype', "auto")
            formData.append('reportdate', "")
            formData.append('taglist', "env.total_irr_avg#" + inverter_id.toLowerCase() + ".active_power#" + inverter_id.toLowerCase() + ".mppt_power#" + pv_arr.join("#"))
            formData.append('validate', "all")

            axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/historical/rawdata", formData, {
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'multipart/form-data;',
                    "Authorization": "Bearer " + props.permitdata.token
                },
            })
                .then((response) => {
                    if (response.data.status === 'OK') {
                        if (response.data.tabledata !== null) {
                            setChart_buffer({
                                ...chart_buffer,
                                label: response.data.xlabel,
                                plot: response.data.tabledata
                            })
                        }
                    } else {

                    }
                })
                .catch((err) => {

                });
        } else {

        }
    }

    async function api_shutdown_send_command(code) {
        if (code.signal === "Reset") {
            setmodal_load({ enable: true, message: "Sending " + code.signal + " Command to Controller...." })
        } else {
            setmodal_load({ enable: true, message: "Sending " + code.signal + " " + code.value + " Command to Controller...." })
        }
        await sleep(500)

        const formData = new FormData()
        formData.append("signal", code.signal)
        formData.append("value", code.value)
        formData.append("circuit", code.circuit)

        axios.post(process.env.REACT_APP_API_URL + props.permitdata.proxy + "/api/measurement/sendshutdown", formData, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'multipart/form-data;',
                "Authorization": "Bearer " + props.permitdata.token
            },
        })
            .then((response) => {
                setmodal_load({ enable: false, message: "" })
                if (response.data.status === 'OK') {
                    setModal_popup({
                        modaltype: 'modal-success',
                        headers: 'Success',
                        message: "Your command has been send to controller.",
                        enable: true
                    });
                } else {
                    setModal_popup({
                        modaltype: 'modal-error',
                        headers: 'Error',
                        message: response.data.message,
                        enable: true
                    })
                }
                if (response.data.indicator !== undefined) {
                    setData_status_indicator(response.data.indicator)
                }
            })
            .catch((err) => {
                setmodal_load({ enable: false, message: "" })
                setModal_popup({
                    modaltype: 'modal-error',
                    headers: 'Error',
                    message: err.message,
                    enable: true
                })
            });
    }

    function GetButton_Enable(data, tag, value) {
        if (data !== undefined) {
            if (data[tag] === value) {
                return false
            } else {
                return true
            }
        } else {
            return true
        }
    }

    function GetButton_Enable_Class(data, tag, value) {
        if (data !== undefined) {
            if (data[tag] === value) {
                return "d-block"
            } else {
                return "d-none"
            }
        } else {
            return "d-none"
        }
    }

    function BackCenter() {
        if (props.permitdata !== null && props.permitdata !== undefined) {
            if (props.permitdata.user_mode !== null && props.permitdata.user_mode !== undefined) {
                if (props.permitdata.user_mode === "center") {
                    return <button className='back-center-btn' onClick={() => {
                        props.callback_backcenter()
                    }}>Back to Center</button>
                }
            }
        }
    }

    return (
        <div id="page-content">
            <div className="panel">
                <div className="panel-body">
                    <div className="row mb-2">
                        <div className="col-xl-12">
                            <div className='d-flex justify-content-between'>
                                <div>
                                    <h4 className="mb-1"><i className="mdi mdi-solar-power color-orange"></i> Inverters</h4>
                                    <p className="mb-1">Inverters monitoring</p>
                                    <h6 className='mb-0'><i className="mdi mdi-clock-time-four-outline"></i> Update : {props.server_update !== "-" ? moment(new Date(props.server_update)).format("YYYY-MM-DD HH:mm:ss") : "Unknown"}</h6>
                                </div>
                                <div>
                                    {BackCenter()}
                                </div>
                            </div>
                            <hr className="new-section-xs mb-0" />
                        </div>
                    </div>

                    <div className='mb-2'>
                        <h5>Electric Circuit Shutdown Command</h5>
                        {
                            props.permitdata.user_role === 'Admin' || props.permitdata.user_role === 'Operator' ?
                                <div className='d-flex justify-content-start flex-wrap gap-3'>
                                    <div className={'inverter-shutdown-btn py-0 ' + GetButton_Enable_Class(data_status_indicator, 'FB_Remote_MCB1_Trip_Main_CMD', false)} onClick={() => { shutdown_trip({ signal: 'AC-Bundle', value: 'Shutdown', circuit: 1 }) }}>
                                        Shutdown AC #1
                                    </div>
                                    <div className={'inverter-recover-btn py-0 ' + GetButton_Enable_Class(data_status_indicator, 'FB_Remote_MCB1_Trip_Main_CMD', true)} onClick={() => { shutdown_trip({ signal: 'AC-Bundle', value: 'Recover', circuit: 1 }) }}>
                                        Recover AC #1
                                    </div>
                                    {
                                        data_status_indicator.solar_type !== "Farm" ?
                                            <>
                                                <div className={'inverter-shutdown-btn py-0 ' + GetButton_Enable_Class(data_status_indicator, 'FB_Remote_MCB1_Trip_Rapid_CMD', false)} onClick={() => { shutdown_trip({ signal: 'DC-Bundle', value: 'Shutdown', circuit: 1 }) }}>
                                                    Shutdown DC #1
                                                </div>
                                                <div className={'inverter-recover-btn py-0 ' + GetButton_Enable_Class(data_status_indicator, 'FB_Remote_MCB1_Trip_Rapid_CMD', true)} onClick={() => { shutdown_trip({ signal: 'DC-Bundle', value: 'Recover', circuit: 1 }) }}>
                                                    Recover DC #1
                                                </div>
                                            </>
                                            :
                                            null
                                    }
                                    {
                                        data_status_indicator.Has_MCB2 === true ?
                                            <>
                                                <div className={'inverter-shutdown-btn py-0 ' + GetButton_Enable_Class(data_status_indicator, 'FB_Remote_MCB2_Trip_Main_CMD', false)} onClick={() => { shutdown_trip({ signal: 'AC-Bundle', value: 'Shutdown', circuit: 2 }) }}>
                                                    Shutdown AC #2
                                                </div>
                                                <div className={'inverter-recover-btn py-0 ' + GetButton_Enable_Class(data_status_indicator, 'FB_Remote_MCB2_Trip_Main_CMD', true)} onClick={() => { shutdown_trip({ signal: 'AC-Bundle', value: 'Recover', circuit: 2 }) }}>
                                                    Recover AC #2
                                                </div>
                                                {
                                                    data_status_indicator.solar_type !== "Farm" ?
                                                        <>
                                                            <div className={'inverter-shutdown-btn py-0 ' + GetButton_Enable_Class(data_status_indicator, 'FB_Remote_MCB2_Trip_Rapid_CMD', false)} onClick={() => { shutdown_trip({ signal: 'DC-Bundle', value: 'Shutdown', circuit: 2 }) }}>
                                                                Shutdown DC #2
                                                            </div>
                                                            <div className={'inverter-recover-btn py-0 ' + GetButton_Enable_Class(data_status_indicator, 'FB_Remote_MCB2_Trip_Rapid_CMD', true)} onClick={() => { shutdown_trip({ signal: 'DC-Bundle', value: 'Recover', circuit: 2 }) }}>
                                                                Recover DC #2
                                                            </div>
                                                        </>
                                                        :
                                                        null
                                                }
                                            </>
                                            :
                                            null
                                    }
                                    {
                                        data_status_indicator.Has_MCB3 === true ?
                                            <>
                                                <div className={'inverter-shutdown-btn py-0 ' + GetButton_Enable_Class(data_status_indicator, 'FB_Remote_MCB3_Trip_Main_CMD', false)} onClick={() => { shutdown_trip({ signal: 'AC-Bundle', value: 'Shutdown', circuit: 3 }) }}>
                                                    Shutdown AC #3
                                                </div>
                                                <div className={'inverter-recover-btn py-0 ' + GetButton_Enable_Class(data_status_indicator, 'FB_Remote_MCB3_Trip_Main_CMD', true)} onClick={() => { shutdown_trip({ signal: 'AC-Bundle', value: 'Recover', circuit: 3 }) }}>
                                                    Recover AC #3
                                                </div>
                                                {
                                                    data_status_indicator.solar_type !== "Farm" ?
                                                        <>
                                                            <div className={'inverter-shutdown-btn py-0 ' + GetButton_Enable_Class(data_status_indicator, 'FB_Remote_MCB3_Trip_Rapid_CMD', false)} onClick={() => { shutdown_trip({ signal: 'DC-Bundle', value: 'Shutdown', circuit: 3 }) }}>
                                                                Shutdown DC #3
                                                            </div>
                                                            <div className={'inverter-recover-btn py-0 ' + GetButton_Enable_Class(data_status_indicator, 'FB_Remote_MCB3_Trip_Rapid_CMD', true)} onClick={() => { shutdown_trip({ signal: 'DC-Bundle', value: 'Recover', circuit: 3 }) }}>
                                                                Recover DC #3
                                                            </div>
                                                        </>
                                                        :
                                                        null
                                                }
                                            </>
                                            :
                                            null
                                    }
                                    {
                                        props.permitdata.sitecode !== '' && props.permitdata.sitecode !== undefined ?
                                            <div className='inverter-panel-btn py-0' onClick={() => { setModal_panel(true) }}>
                                                Control Panel
                                            </div>
                                            :
                                            null
                                    }
                                </div>
                                :
                                null
                        }
                        <hr className="new-section-xs mt-2 mb-2" />
                    </div>

                    <div className="row">
                        {
                            data_inverter !== undefined ?
                                data_inverter.map((inverter, index) => (
                                    <div className="col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3 col-xxxl-2" key={inverter.inverter_id_text}>
                                        <CardInverter
                                            invno={inverter.inverter_id_text}
                                            data={inverter}
                                            onClick={(cmd) => { setInverter_selected(cmd); setChart_mode("ac_type") }}
                                        />
                                    </div>
                                ))
                                :
                                null
                        }
                    </div>

                </div>
            </div>

            {
                inverter_selected !== '' && inverter_item !== null && inverter_item ?
                    inverter_item.inverter_id_text !== undefined ?
                        <DeviceInfo_Inverter
                            data_uioption={data_uioption}
                            inverter_item={inverter_item}
                            chart_plot={chart_plot}
                            chart_plot_string={chart_plot_string}
                            string_tag_list={string_tag_list}
                            string_selected={string_selected}
                            chart_mode={chart_mode}
                            onClose={() => {
                                setInverter_selected('');
                                setString_selected({
                                    datakey: '',
                                    tags: ''
                                });
                                setChart_plot({
                                    ...chart_plot,
                                    IRR: [],
                                    Power: [],
                                })
                            }}
                            onSelected_ChartMode={setChart_mode}
                            onSelected_String={setString_selected}
                        ></DeviceInfo_Inverter>
                        :
                        null
                    :
                    null
            }
            {
                modal_panel ?
                    <div className='modal-overlay'>
                        <div className="modal d-block" >
                            <div className="modal-dialog modal-lg modal-fullscreen-md-down modal-dialog-centered">
                                <div className="modal-content">
                                    <div className="modal-header">
                                        <h4 className="modal-title "><i className="fas fa-power-off text-danger"></i> Shutdown Control Panel</h4>
                                        <i className="fe-x modal-close" onClick={() => { setModal_panel(false) }}></i>
                                    </div>
                                    <div className="modal-body">
                                        <div className="d-block mb-2">
                                            <h6>Main AC Shutdown #1 Command</h6>
                                            <div className="d-flex gap-3">
                                                <div className="d-flex gap-3">
                                                    <button className="btn btn-danger" type="button" onClick={() => { shutdown_trip({ signal: 'AC', value: 'Shutdown', circuit: 1 }) }} style={{ width: "120px" }} disabled={GetButton_Enable(data_status_indicator, 'FB_Remote_MCB1_Trip_Main_CMD', false)}>Shutdown AC</button>
                                                    <button className="btn btn-light" type="button" onClick={() => { shutdown_trip({ signal: 'AC', value: 'Recover', circuit: 1 }) }} style={{ width: "120px" }} disabled={GetButton_Enable(data_status_indicator, 'FB_Remote_MCB1_Trip_Main_CMD', true)}>Recover AC</button>
                                                </div>
                                                {
                                                    data_status_indicator.solar_type !== "Farm" ?
                                                        <>
                                                            <div className="d-flex gap-3">
                                                                <button className="btn btn-danger" type="button" onClick={() => { shutdown_trip({ signal: 'DC', value: 'Shutdown', circuit: 1 }) }} style={{ width: "120px" }} disabled={GetButton_Enable(data_status_indicator, 'FB_Remote_MCB1_Trip_Rapid_CMD', false)}>Shutdown DC</button>
                                                                <button className="btn btn-light" type="button" onClick={() => { shutdown_trip({ signal: 'DC', value: 'Recover', circuit: 1 }) }} style={{ width: "120px" }} disabled={GetButton_Enable(data_status_indicator, 'FB_Remote_MCB1_Trip_Rapid_CMD', true)}>Recover DC</button>
                                                            </div>
                                                        </>
                                                        :
                                                        null
                                                }
                                            </div>
                                            {
                                                data_status_indicator.Has_MCB2 === true ?
                                                    <>
                                                        <h6 className='mt-3'>Main AC Shutdown #2 Command</h6>
                                                        <div className="d-flex gap-3">
                                                            <div className="d-flex gap-3">
                                                                <button className="btn btn-danger" type="button" onClick={() => { shutdown_trip({ signal: 'AC', value: 'Shutdown', circuit: 2 }) }} style={{ width: "120px" }} disabled={GetButton_Enable(data_status_indicator, 'FB_Remote_MCB2_Trip_Main_CMD', false)}>Shutdown AC</button>
                                                                <button className="btn btn-light" type="button" onClick={() => { shutdown_trip({ signal: 'AC', value: 'Recover', circuit: 2 }) }} style={{ width: "120px" }} disabled={GetButton_Enable(data_status_indicator, 'FB_Remote_MCB12_Trip_Main_CMD', true)}>Recover AC</button>
                                                            </div>
                                                            {
                                                                data_status_indicator.solar_type !== "Farm" ?
                                                                    <>
                                                                        <div className="d-flex gap-3">
                                                                            <button className="btn btn-danger" type="button" onClick={() => { shutdown_trip({ signal: 'DC', value: 'Shutdown', circuit: 2 }) }} style={{ width: "120px" }} disabled={GetButton_Enable(data_status_indicator, 'FB_Remote_MCB2_Trip_Rapid_CMD', false)}>Shutdown DC</button>
                                                                            <button className="btn btn-light" type="button" onClick={() => { shutdown_trip({ signal: 'DC', value: 'Recover', circuit: 2 }) }} style={{ width: "120px" }} disabled={GetButton_Enable(data_status_indicator, 'FB_Remote_MCB2_Trip_Rapid_CMD', true)}>Recover DC</button>
                                                                        </div>
                                                                    </>
                                                                    :
                                                                    null
                                                            }
                                                        </div>
                                                    </>
                                                    :
                                                    null
                                            }
                                            {
                                                data_status_indicator.Has_MCB3 === true ?
                                                    <>
                                                        <h6 className='mt-3'>Main AC Shutdown #3 Command</h6>
                                                        <div className="d-flex gap-3">
                                                            <div className="d-flex gap-3">
                                                                <button className="btn btn-danger" type="button" onClick={() => { shutdown_trip({ signal: 'AC', value: 'Shutdown', circuit: 3 }) }} style={{ width: "120px" }} disabled={GetButton_Enable(data_status_indicator, 'FB_Remote_MCB3_Trip_Main_CMD', false)}>Shutdown AC</button>
                                                                <button className="btn btn-light" type="button" onClick={() => { shutdown_trip({ signal: 'AC', value: 'Recover', circuit: 3 }) }} style={{ width: "120px" }} disabled={GetButton_Enable(data_status_indicator, 'FB_Remote_MCB3_Trip_Main_CMD', true)}>Recover AC</button>
                                                            </div>
                                                            {
                                                                data_status_indicator.solar_type !== "Farm" ?
                                                                    <>
                                                                        <div className="d-flex gap-3">
                                                                            <button className="btn btn-danger" type="button" onClick={() => { shutdown_trip({ signal: 'DC', value: 'Shutdown', circuit: 3 }) }} style={{ width: "120px" }} disabled={GetButton_Enable(data_status_indicator, 'FB_Remote_MCB3_Trip_Rapid_CMD', false)}>Shutdown DC</button>
                                                                            <button className="btn btn-light" type="button" onClick={() => { shutdown_trip({ signal: 'DC', value: 'Recover', circuit: 3 }) }} style={{ width: "120px" }} disabled={GetButton_Enable(data_status_indicator, 'FB_Remote_MCB3_Trip_Rapid_CMD', true)}>Recover DC</button>
                                                                        </div>
                                                                    </>
                                                                    :
                                                                    null
                                                            }
                                                        </div>
                                                    </>
                                                    :
                                                    null
                                            }
                                            <h6 className='mt-3'>Lighting On/Off Command</h6>
                                            <div className="d-flex gap-3 mt-2">
                                                <button className="btn btn-warning" type="button" onClick={() => { shutdown_trip({ signal: 'Lighting', value: 'Turn On' }) }} style={{ width: "120px" }} disabled={GetButton_Enable(data_status_indicator, 'FB_Remote_Lighting_CMD', false)}>Turn On</button>
                                                <button className="btn btn-light" type="button" onClick={() => { shutdown_trip({ signal: 'Lighting', value: 'Turn Off' }) }} style={{ width: "120px" }} disabled={GetButton_Enable(data_status_indicator, 'FB_Remote_Lighting_CMD', true)}>Turn Off</button>
                                            </div>
                                            <h6 className='mt-3'>Buzzer On/Off Command</h6>
                                            <div className="d-flex gap-3 mt-2">
                                                <button className="btn btn-warning" type="button" onClick={() => { shutdown_trip({ signal: 'Buzzer', value: 'Turn On' }) }} style={{ width: "120px" }} disabled={GetButton_Enable(data_status_indicator, 'FB_Remote_Buzzer_CMD', false)}>Turn On</button>
                                                <button className="btn btn-light" type="button" onClick={() => { shutdown_trip({ signal: 'Buzzer', value: 'Turn Off' }) }} style={{ width: "120px" }} disabled={GetButton_Enable(data_status_indicator, 'FB_Remote_Buzzer_CMD', true)}>Turn Off</button>
                                            </div>
                                            <h6 className='mt-3'>Common Command</h6>
                                            <div className="d-flex gap-3 mt-2">
                                                <button className="btn btn-success" type="button" onClick={() => { shutdown_trip({ signal: 'Reset', value: 'Turn On' }) }} style={{ width: "255px" }}>Reset All Command</button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="modal-footer py-1">
                                        <button className="btn btn-light btn-sm" type="button" onClick={() => { setModal_panel(false) }}><i className="fe-x"></i> Close</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    :
                    null
            }

            <ScrollToTopButton />
            {modal_load.enable ? <ModalLoad option={modal_load} /> : null}
            {modal_popup.enable ? <ModalPopupMessage option={modal_popup} onConfirm={PopupMsg_onConfirm} onGeneral={PopupMsg_onGeneral} /> : null}
        </div>
    )
}
export default MeasurementInverters